/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { DegreeMarketing_GenericUpsellResponse as DegreeUpsellData } from '__generated__/graphql-types-do-not-use';

import styles from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/styles';
import HelpTipCardWithDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/HelpTipCardWithDialog';
import NeedMoreFlexibilityContent from 'bundles/degree-home/components/v3-dpm/components/HelpTips/NeedMoreFlexibilityContent';
import useDegreeUpsell from 'bundles/degree-home/components/v3-dpm/lib/useDegreeUpsell';

import _t from 'i18n!nls/degree-home';

export const OFFERS_CREDIT = 'OFFERS_CREDIT';
export const PART_OF = 'PART_OF';

export type DegreeUpsellArray = Array<Pick<DegreeUpsellData, 'upsellType'>>;

/**
 * Check if the degree is stackable.
 * A degree is stackable if it has at least one upsell of type OFFERS_CREDIT or PART_OF
 * @param {Array<DegreeUpsellData>} degreeUpsellData
 * @returns {boolean}
 * @private
 */
const getStackability = (degreeUpsellData: DegreeUpsellArray) => {
  return degreeUpsellData.some(({ upsellType }) => upsellType === OFFERS_CREDIT || upsellType === PART_OF);
};

const TipNeedMoreFlexibility = () => {
  const { degreeUpsellData } = useDegreeUpsell();

  const supportsStackability = degreeUpsellData && getStackability(degreeUpsellData);

  if (!supportsStackability) {
    return null;
  }

  return (
    <HelpTipCardWithDialog
      title={_t('Need more flexibility?')}
      tip={_t('Enroll in a non-credit degree course and upgrade to for-credit later.')}
      dialogTitle={_t('Academic Tips')}
      dialogMessage={<NeedMoreFlexibilityContent css={styles.modalContentSegmentPadding} />}
    />
  );
};

export default TipNeedMoreFlexibility;
